const __WEBPACK_NAMESPACE_OBJECT__ = require("core-js/modules/es.regexp.constructor.js");